import React from "react";
import { Link } from "react-router-dom";
import styled from 'styled-components';
import { colours, heights } from "../Styles";
import FlexCenterCenter from './FlexCenterCenter';

function PromoBanner() {
    const {accent, light} = colours;
    const {headerHeight, mobileHeader, contactBar} = heights;
    const content = 'FREE STEAM CLEANING with any package';
    const PromoBanner = styled.div`
    height: 40px;
    width: 100%;
    position: fixed;
    background: ${accent};
    top: calc(${headerHeight} + ${contactBar});
    z-index: 5;
    h5 {
        font-size: 14px;
        font-weight: 400;
        font-family: "Play", sans-serif;
        color: ${light};
        text-align: center;
    }
    @media only screen and (max-width: 600px) {
      top: ${mobileHeader};
      height: 30px;
      h5 {font-size: 11px;}
    }
    // Shows and hides bar if content exists or not.
    `;
    var hidden = {display: 'block'};
    if (content === '') {
      hidden = {display: 'none'};
    } else {
      hidden = {display: 'block'};
    }
  return (
    <PromoBanner style={hidden}>
        <FlexCenterCenter>
        <Link to="/services">
            <h5>{content}</h5>
        </Link>
        </FlexCenterCenter>
    </PromoBanner>
  );
}

export default PromoBanner;
